import { OreDivider, OreStack } from '@edenredespana/oreneta'
import { useTranslation } from 'react-i18next'

import { createHelpCenterRepository } from '@/HelpCenter/infrastructure/ApiHelpCenterRepository'
import { HelpCenterProvider } from '@/HelpCenter/ui/context'
import { MyTicketsList } from '@/HelpCenter/ui/organisms/MyTicketsList'
import { ExpandableFaq } from '@/Shared/ui/expandableFaq/ui/organisms/ExpandableFaq'

import { HelpCenterTranslations } from '../helpCenterTranslations'
import { CoBrowsing } from '../organisms/CoBrowsing'

export const MyTicketsPage = (): JSX.Element => {
  const { t } = useTranslation()

  return (
    <HelpCenterProvider repository={createHelpCenterRepository()}>
      <div
        className="page-wrapper"
        style={{
          paddingTop: '102px',
          display: 'flex',
          flexDirection: 'column',
          minHeight: '100vh',
          paddingBottom: '12px',
          gap: '2.5rem',
        }}
      >
        <MyTicketsList />
        <OreDivider />
        <ExpandableFaq
          title={t(HelpCenterTranslations.coBrowsing.expandableFaq.title)}
          description={t(HelpCenterTranslations.coBrowsing.expandableFaq.description)}
          children={<CoBrowsing />}
        />
      </div>
    </HelpCenterProvider>
  )
}
